import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  margin-top: 120px;
  flex-direction: column;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  padding: 30px 0;
  min-height: 100vh;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 30px;
  color: ${({ theme }) => theme.title};
  text-align: center;
`;

export const FormContainer = styled.div`
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  padding: 30px;
  background-color: ${({ theme }) => theme.backgroundSecondary};
  border-radius: 12px;
  margin-bottom: 40px;
`;

export const FormGroup = styled.div`
  margin-bottom: 25px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 10px;
  font-weight: 500;
  color: ${({ theme }) => theme.label};
  font-size: 16px;
`;

export const Input = styled.input`
  width: 93%;
  padding: 12px 15px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.inputBackgroundAccount};
  color: ${({ theme }) => theme.text};
  font-size: 16px;
  
  &:focus {
    border-color: ${({ theme }) => theme.primaryAccent};
    outline: none;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 12px 30px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
  
  &:disabled {
    background-color: ${({ theme }) => theme.border};
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.error};
  margin-top: 10px;
  font-size: 14px;
`;

export const SuccessMessage = styled.div`
  color: ${({ theme }) => theme.success};
  margin-top: 10px;
  font-size: 14px;
`; 